<template>
  <div class="container">
    <!--  API ERROR  -->
    <div v-if="axiosError">
      <p class="code mt-6">{{ axiosError?.response?.status }}</p>
      <p class="text-code mb-4">API ERROR</p>
      <p class="sub-title my-2">method: {{ axiosError.response?.config.method || '–' }}</p>
      <p class="sub-title my-2">url: {{ axiosError.response?.config.url || '–' }}</p>
      <p
        class="sub-title my-2"
        style="max-height: 200px; overflow: auto"
      >
        data: {{ axiosError.response?.config.data || '–' }}
      </p>
      <p class="sub-title my-2">error code: {{ axiosError.code }}</p>
      <p class="sub-title my-2">status text: {{ axiosError.response?.statusText || '–' }}</p>
      <p class="sub-title my-2">api requestId: {{ axiosError.response?.data?.requestId || '–' }}</p>
      <p class="sub-title my-2">
        api error code: {{ axiosError.response?.data?.data?.errorCode || '–' }}
      </p>

      <p class="title my-4">{{ error.message }}</p>
    </div>

    <!--  CLIENT ERRORS  -->
    <div v-else>
      <p class="code mt-6">{{ error?.statusCode || 400 }}</p>
      <p class="text-code mb-4">client error</p>
      <p class="title my-2">
        {{
          error?.message ||
          'При загрузке возникла необработанная ошибка, обратитесь в службу поддержки'
        }}
      </p>
      <div class="trace my-2 mx-2">{{ error.stack }}</div>
    </div>

    <v-btn
      class="font-weight-bold my-4"
      color="primary"
      :text="redirectLink.label"
      @click="redirect()"
    />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import axios, { AxiosError } from 'axios';

type AxiosErrorResponseData = {
  requestId: string;
  data: {
    errorCode: string;
  };
};

export type AxiosErrorData = {
  error: AxiosError<AxiosErrorResponseData>;
};

export type ClientErrorData = {
  redirectLink?: {
    label: string;
    to: string;
  };
};

const { error } = defineProps<{ error: NuxtError<ClientErrorData | AxiosErrorData> }>();

const isAxiosError = axios.isAxiosError((error.data as AxiosErrorData)?.error);
const axiosError = isAxiosError ? (error.data as AxiosErrorData).error : undefined;
const clientError = !isAxiosError ? (error as NuxtError<ClientErrorData>) : undefined;

const redirectLink = computed(
  () =>
    (clientError && (error as NuxtError<ClientErrorData>).data?.redirectLink) || {
      label: 'Вернуться домой',
      to: '/',
    },
);

useHead({
  title: `${error.message}`,
  meta: [{ name: 'robots', content: 'noindex, nofollow' }],
});

function redirect() {
  clearError({ redirect: redirectLink.value.to });
}
</script>

<style lang="scss" scoped>
.code {
  font-weight: 200;
  font-size: 150px;
  line-height: 150px;
  text-align: center;
  color: #1e598f;

  @include respond-to(mobile) {
    font-size: 120px;
    line-height: 120px;
  }
}

.text-code {
  font-weight: 200;
  font-size: 80px;
  line-height: 80px;
  text-align: center;
  color: #1e598f;

  @include respond-to(mobile) {
    font-size: 60px;
    line-height: 60px;
  }
}

.title {
  font-weight: 400;
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  text-wrap: wrap;
  color: #1e588fbe;

  @include respond-to(mobile) {
    font-size: 20px;
    line-height: 20px;
  }
}

.sub-title {
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  text-wrap: wrap;
  color: #1e588fbe;

  @include respond-to(mobile) {
    font-size: 16px;
    line-height: 16px;
  }
}

.trace {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #52575b;
  text-wrap: wrap;
  text-overflow: ellipsis;
  overflow: auto;

  @include respond-to(mobile) {
    font-size: 10px;
    line-height: 12px;
    max-height: 200px;
  }
}

.container {
  position: absolute;
  height: 80vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  padding: 16px;

  align-items: center;
  justify-content: center;

  @media (max-height: 460px) {
    height: 100%;
    justify-content: unset;
  }
}
</style>
